module.exports = __webpack_public_path__ + "dfa670ccd28394d603e31071f6a168ca.jpg";